export const BLACK = '#000000';
export const HEADLINER_GRADIENT = 'linear-gradient(135deg, #5dbefc, #dd92fe)';
export const INSTAGRAM_GRADIENT =
  'linear-gradient(171deg, #6c14c6 6%, #f1532e 60%, #f8c45c 95%)';
export const FACEBOOK_BLUE = '#3b5998';
